<div class="feedback-body">
  <div class="form-group">
    <div class="uba-control-group">
      <label
        for="category"
        class="required"
        [translate]="'feedback.kategorie'"
      ></label>
      <div class="uba-form-control">
        <select 
          autoFocus
          id="category"
          name="category"
          class="form-control"
          [(ngModel)]="createFeedback.kategorie">
          <option *ngFor="let item of categoryItems" [ngValue]="item.value">{{ item.text }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-control-group">
      <label
        class="required"
        [translate]="'feedback.beschreibung'"
        for="area_description"
      ></label>
      <div class="uba-form-control">
        <textarea
          class="form-control"
          rows="5"
          placeholder="{{ 'feedback.beschreibung' | translate }}"
          [(ngModel)]="createFeedback.beschreibung"
          name="description"
          id="area_description"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="createFeedback.kategorie == 'EintragInNachschlagetabelle'">
    <div class="uba-control-group">
      <label
        [translate]="'feedback.nachschlageTabelleName'"
        for="tb_nachschlageTabelleName"
      ></label>
      <div class="uba-form-control">
        <input
          type="text"
          class="form-control"
          placeholder="{{ 'feedback.nachschlageTabelleName' | translate }}"
          [(ngModel)]="createFeedback.nachschlageTabelleName"
          name="nachschlageTabelleName"
          id="tb_nachschlageTabelleName"
        />
      </div>
    </div>
  </div>
  <div class="form-group" *ngIf="createFeedback.kategorie == 'EintragInNachschlagetabelle'">
    <div class="uba-control-group">  
      <label       
        [translate]="'feedback.nachschlageTabelleWert'"
        for="tb_nachschlageTabelleWert"
      ></label>
      <div class="uba-form-control">
        <textarea
          class="form-control"
          rows="2"
          placeholder="{{ 'feedback.nachschlageTabelleWert' | translate }}"
          [(ngModel)]="createFeedback.nachschlageTabelleWert"
          name="nachschlageTabelleWert"
          id="tb_nachschlageTabelleWert"
        ></textarea>
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-control-group">
      <label [translate]="'feedback.url'"></label>
      <div class="uba-form-control">
        <input 
          type="text"
          class="form-control" 
          [disabled]="true" 
          [value]="createFeedback.url" 
          name="url" 
          id="tb_url" />
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-control-group">
      <label
        for="priority"
        class="required"
        [translate]="'feedback.prioritaet'"
      ></label>
      <div class="uba-form-control">
        <select 
          id="priority"
          name="priority"
          class="form-control"
          [(ngModel)]="createFeedback.prioritaet">
          <option *ngFor="let item of priorityItems" [ngValue]="item.value">{{ item.text }}</option>
        </select>
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="uba-checkbox-group">
      <label
        [translate]="'feedback.emailErwartet'"
        for="cb_emailExpected"
      ></label>
      <div>
        <input
          type="checkbox"
          [(ngModel)]="createFeedback.emailErwartet"
          [ngModelOptions]="{ standalone: true }"
          name="cb_emailExpected"
          id="cb_emailExpected"
        />      
      </div>
    </div>
  </div>  
  <div class="form-group">
    <div class="uba-control-group">
      <label 
        [translate]="'feedback.anhaenge'"
        id="label-file-upload"
        for="file-upload">
      </label>
    </div>
    <div>
      <app-generic-upload
        [inputId]="'file-upload'"
        [uploadUrl]="uploadUrl"
        [restrictions]="{ maxFileSize: 4194304 }"
        [(files)]="files"
        [multiple]="true"
        [autoUpload]="true"
        [showRetryButton]="true"
        [showRemoveButton]="true"
        (uploadError)="onError($event)"
        aria-labelledby="label-file-upload">
      </app-generic-upload>  
    </div>
  </div>
  <div class="uba-button-group">
    <button (click)="cancel()" class="btn btn-default" id="btn_cancel">
      {{ 'action.cancel' | translate }}
    </button>
    <button (click)="send()" [disabled]="!canSend" class="btn btn-primary" id="btn_send">
      <i class="far fa-paper-plane" aria-hidden="true"></i> {{ 'action.send' | translate }}
    </button>
  </div>
</div>
